import { useStore } from "vuex";
import { useCategoriesStore } from "@/stores/categories/index.ts";

export default function useCategoriesData() {
  const store = useStore();
  const categoriesStore = useCategoriesStore();

  async function loadCategoriesData(params, isSubCategory = false) {
    const promises = [
      categoriesStore.fetch(),
      store.dispatch("api/fetchAllCategories"),
      store.dispatch("filterBar/clearLastUsedFilters"),
      store.dispatch("setSiteBuilderFormVar", {
        key: "siteBuilderForm",
        value: { selections: [] },
      }),
      store.dispatch("setSiteBuilderFormVar", {
        key: "steps",
        value: ["Selection", "Confirmation"],
      }),
    ];

    if (isSubCategory) {
      const id = params.categoryID;
      promises.push(store.dispatch("api/fetchCategory", { id }));
    }

    await Promise.all(promises);

    const { categories } = store.state.api;

    await store.dispatch(
      "setPageData",
      { pageName: "Categories", data: categories },
      { root: true }
    );

    if (isSubCategory) {
      const category = store.getters["api/category"](params.categoryID);
      await store.dispatch(
        "setPageData",
        { pageName: "SubCategories", data: category },
        { root: true }
      );
    }

    // Side menu and move documents modal need all category docs
    if (!store.getters["api/allCategories"]().length) {
      await store.dispatch("api/fetchAllCategories");
    }
  }

  return {
    loadCategoriesData,
  };
}
